import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AssignmentService {
    constructor(private http: HttpClient) { }
    getAssignment(perPage:number, page:number) {
        return this.http.get<any>(`${environment.apiUrl}/assignment/assignment?perPage=${perPage}&page=${page}&order_way=desc`)
    };
    getAssignmentContentId(perPage:number, page:number, id:string) {
        return this.http.get<any>(`${environment.apiUrl}/assignment/content?perPage=${perPage}&page=${page}&assignment=${id}`)
    };
    getAssignmentContent(perPage:number, page:number) {
        return this.http.get<any>(`${environment.apiUrl}/assignment/content?perPage=${perPage}&page=${page}`)
    };
    updateStatus(id:string, status:number){
        var data = {
            "status": status
        }
        return this.http.patch<any>(`${environment.apiUrl}/assignment/content/${id}`, data);
    }
    postAssignment(data:any) {
        return this.http.post<any>(`${environment.apiUrl}/assignment/assignment`, data)
    }

    postAssignmentContent(data:any) {
        return this.http.post<any>(`${environment.apiUrl}/assignment/content`, data)
    }
}